/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  const stateKeys = [
    "OPEN",
    "PUBLISHED",
    "CLEARED",
    "WAITING_SETTLEMENT",
    "WAITING_DSO_COEFFICIENTS",
    "WAITING_DSO_INFO",
    "NO_TRANSACTIONS",
    "SETTLED",
    "ERROR",
    "LOADS_CONVERSION_ERROR",
    "CLEAR_ERROR",
    "SETTLEMENT_ERROR",
  ];

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("market_list.title")}
      </Typography>
      <hr />

      <Typography variant="h3" mt={4} ml={2}>
        {t("market_list.about.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market_list.about.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("market_list.session_state.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market_list.session_state.intro")}
        </Box>
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {stateKeys.map((k) => (
            <Typography key={k} component="div" variant="text" fontSize="1rem" mt={1}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                - {t(`market_list.session_state.states.${k}`)}
              </Typography>
            </Typography>
          ))}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("market_list.message.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market_list.message.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("market_list.offers.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market_list.offers.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("market_list.transactions.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market_list.transactions.body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
